import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React from "react";

import { initMap, show } from "../../../services/shift_monitoring/breaks/map";
import { BreaksState } from "../store";

import {
    convertMinToDisplayFormat,
    convertNeedGuidanceToBatsuMark,
} from "../../../services/common/convert";
import {
    breaksPositionHighlightLyr,
    breaksPositionLyr,
} from "../../../services/shift_monitoring/breaks/layers";
import { convertShiftDateToJpn } from "../../../utils/formatting";
import { BreaksTable } from "./Table";

interface Props {
    breakstate: BreaksState;
}

let map;

export const Header: React.FC<Props> = (props: Props) => {
    return (
        <Box sx={{ p: 3 }}>
            <Box sx={{ display: "flex" }}>
                <Box sx={{ p: 3 }}>
                    {convertShiftDateToJpn(props.breakstate.shiftDate)}
                </Box>
                <Box sx={{ p: 3 }}>{props.breakstate.driverName}</Box>
                <Box sx={{ p: 3 }}>
                    乗務時間:{" "}
                    {convertMinToDisplayFormat(
                        parseInt(props.breakstate.shiftMin, 10)
                    )}
                </Box>
            </Box>
            <Typography variant="h2" gutterBottom component="div">
                <Box sx={{ display: "flex", alignItems: "baseline" }}>
                    <Box sx={{ p: 3 }}>停車時間</Box>
                    <Box
                        sx={{
                            p: 3,
                        }}
                    >
                        {convertMinToDisplayFormat(
                            parseInt(props.breakstate.breaksMin, 10)
                        )}
                    </Box>
                    <Box>
                        {convertNeedGuidanceToBatsuMark(
                            props.breakstate.needGuidance
                        )}
                    </Box>
                </Box>
            </Typography>
        </Box>
    );
};

export const updater = (lng?: number, lat?: number, zoomrec: any = null) => {
    if (!lng || !lat) {
        return;
    }
    (map as mapboxgl.Map).setCenter([lng, lat]);
    (map as mapboxgl.Map).setZoom(13);

    if (!zoomrec) {
        return;
    }
    [breaksPositionLyr, breaksPositionHighlightLyr].forEach((layer) => {
        const newFilter = ["==", "recId", zoomrec];
        map.setFilter(layer.id, newFilter);
    });
};

export class BreaksScreen extends React.Component<Props> {
    constructor(props: any) {
        super(props);
    }

    mapContainer;

    componentDidMount = async (): Promise<any> => {
        map = await initMap(this.mapContainer);
    };

    render = () => {
        if (map && this.props.breakstate.breaks) {
            const breaksData = this.props.breakstate.breaks;
            show(map, breaksData);

            if (breaksData[0]) {
                const zoomRecord = breaksData[0];
                updater(zoomRecord.breakLocLng, zoomRecord.breakLocLat);
            }
        }

        return (
            <Box id="Breaks-Screen">
                <Header {...this.props} />
                <Box
                    id="Breaks-main-container"
                    sx={{
                        display: "flex",
                        alignItems: "top",
                    }}
                >
                    <Box
                        id="Breaks-table-container"
                        sx={{
                            minWidth: "40%",
                        }}
                    >
                        <BreaksTable breaks={this.props.breakstate.breaks} />
                    </Box>

                    <Box
                        id="Breaks-map-container"
                        sx={{
                            flexGrow: 2000,
                        }}
                    >
                        <Box
                            id="breaksMap"
                            sx={{
                                m: 3,
                                ml: 4,
                                minHeight: "800px",
                                minWidth: "700px",
                                width: "100%",
                                cursor: "pointer",
                            }}
                            ref={(el) => (this.mapContainer = el)}
                        />
                    </Box>
                </Box>
            </Box>
        );
    };
}
